import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

// Outlined "dock" / right-panel glyph: a panel outline with a docked
// right column. Drawn with `currentColor` (stroke, no fill) so it picks
// up the surrounding text colour — e.g. the icon-gray token via
// `text-gray-600`. (`right_panel_inverted` stays the solid white variant
// for dark canvas backgrounds.)
const RightPanelIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <g
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
        >
            <rect x="3" y="4" width="18" height="16" rx="2" />
            <line x1="15" y1="4" x2="15" y2="20" />
        </g>
    </SvgIcon>
);

export default RightPanelIcon;
